import { createFileRoute } from '@tanstack/react-router'
import { getTranslations } from '@/i18n/translator'
import { pageHead } from '@/lib/seo'
import { faqSchema } from '@/lib/structured-data'
import { useScrollDepth } from '@/lib/analytics/use-scroll-depth'
import { HeroSection } from '@/features/landing-page/components/hero-section'
import { LogosSection } from '@/features/landing-page/components/logos-section'
import { QuoteSection } from '@/features/landing-page/components/quote-section'
import { AppsSection } from '@/features/landing-page/components/apps-section'
import { AppDetailSections } from '@/features/landing-page/components/app-detail-section'
import { CompareSection } from '@/features/landing-page/components/compare-section'
import { TailoredSection } from '@/features/landing-page/components/tailored-section'
import { DataOwnershipSection } from '@/features/landing-page/components/data-ownership-section'
import { DEFAULT_FAQ_ITEMS, FaqSection } from '@/features/landing-page/components/faq-section'
import { FinalCtaSection } from '@/features/landing-page/components/final-cta-section'

export const Route = createFileRoute('/$locale/')({
  loader: async ({ params }) => {
    const [t, faqT] = await Promise.all([
      getTranslations({ locale: params.locale, namespace: 'home' }),
      getTranslations({ locale: params.locale, namespace: 'home.faq' }),
    ])
    const faq = DEFAULT_FAQ_ITEMS.map((key) => ({
      question: faqT(`items.${key}.question`),
      answer: faqT(`items.${key}.answer`),
    }))
    return { title: t('meta.title'), description: t('meta.description'), faq }
  },
  head: ({ loaderData, params }) =>
    pageHead({
      locale: params.locale,
      path: '',
      title: loaderData?.title ?? 'CountAct',
      description: loaderData?.description ?? '',
      jsonLd: faqSchema(loaderData?.faq),
    }),
  component: Home,
})

function Home() {
  useScrollDepth('home')
  return (
    <>
      <HeroSection />
      <LogosSection />
      <QuoteSection />
      <AppsSection />
      <AppDetailSections />
      <CompareSection />
      <TailoredSection />
      <DataOwnershipSection />
      <FaqSection />
      <FinalCtaSection trackSectionView />
    </>
  )
}
